import * as yup from "yup";

export const DocumentoSchema = yup.object().shape({
  codigo: yup
    .string()
    .max(6, "errors.documento.codigo.max")
    .required("errors.documento.codigo.required"),
  nombre: yup
    .string()
    .max(255, "errors.documento.nombre.max")
    .required("errors.documento.nombre.required"),
  descripcion: yup
    .string()
    .max(1024, "errors.documento.descripcion.max")
    .required("errors.documento.descripcion.required"),
});
